<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapterNumber" id="_idParaDest-1">Contents</h1>
<p class="center"><a href="#/TacklingTheTeam3">Introduction</a></p>
<p class="center"><a href="#/TacklingTheTeam4">One</a></p>
<p class="center"><span href="#/TacklingTheTeam5" title="Link target outside of Sample">Two</span></p>
<p class="center"><span href="#/TacklingTheTeam6" title="Link target outside of Sample">Three</span></p>
<p class="center"><span href="#/TacklingTheTeam7" title="Link target outside of Sample">Four</span></p>
<p class="center"><span href="#/TacklingTheTeam8" title="Link target outside of Sample">Five</span></p>
<p class="center"><span href="#/TacklingTheTeam9" title="Link target outside of Sample">Six</span></p>
<p class="center"><span href="#/TacklingTheTeam10" title="Link target outside of Sample">Seven</span></p>
<p class="center"><span href="#/TacklingTheTeam11" title="Link target outside of Sample">Eight</span></p>
<p class="center"><span href="#/TacklingTheTeam12" title="Link target outside of Sample">Nine</span></p>
<p class="center"><span href="#/TacklingTheTeam13" title="Link target outside of Sample">Ten</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TacklingTheTeam1.vue?f0cea868